export default __webpack_public_path__ + "static/media/SwamijiNew5.998b2a07.JPG";